export const processResponse = (promise, field) => new Promise((resolve, reject) => {
    promise.then((response) => {
        if (response.error) {
            return reject(response.error);
        }
        return resolve(response.data[field]);
    }).catch((error) => reject(error));
});

export default {
    processResponse,
};